import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['select', 'intputSearch', 'intputResults', 'list', 'dropdown'];

  connect() {
    this.selections = [];
    this.options = [...this.selectTarget.options].map((o) => {
      let name = o.dataset.searchfield || o.text;
      if (o.selected) this.selections.push({ id: o.value, name: name, displayName: o.text })
      return { id: o.value, name: name, displayName: o.text }
    });
    this.multiple = this.selectTarget.multiple;
    this.withClearBtn = this.selectTarget.dataset.withClearBtn;
    this.drawControls();
    this.filteredOptions = this.options;
    this.addEvents();
    this.apply();
    this.render();
    if (this.selectTarget.dataset.cleared == 'true') {
      this.clear();
    }
  }

  drawControls() {
    this.selectTarget.style.display = 'none';
    var placeholder = this.selectTarget.dataset.prompt;
    if (placeholder === undefined) {
      placeholder = '';
    };

    this.element.insertAdjacentHTML('beforeend',
      `
    <div class="select-search-box">
      <div class="field has-addons" style="margin-bottom: 0;">
        <div class="control has-icons-right" style="width: 100%;">
          <input class="input ${this.selectTarget.dataset.class}" placeholder="${placeholder}" data-target="${this.identifier}.intputResults" readonly />
          <span class="icon is-small is-right">
            <i class="fas fa-chevron-down"></i>
          </span>
        </div>
        ${this.withClearBtn && this.selections.length > 0 ? `
          <div class="control">
            <button type="button" class="button is-danger ${this.selectTarget.dataset.class}" data-action="${this.identifier}#clear">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </button>
          </div>` : ``
      }
      </div>

      <div class="select-search-list catalog-pulled-right" data-target="${this.identifier}.dropdown">
        <div class="select-search-input field has-addons">
          <div class="control has-icons-left is-expanded">
            <input class="input" data-target="${this.identifier}.intputSearch" />
            <span class="icon is-small is-left">
              <i class="fas fa-search"></i>
            </span>
          </div>
          <div class="control">
            <button type="button" class="button has-text-danger" data-action="${this.identifier}#filterEmpty">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </button>
          </div>
        </div>
        <div class="select-search-results" data-target="${this.identifier}.list">
        </div>
      </div>
    </div>`
    );

    if (this.multiple) {
      this.dropdownTarget.insertAdjacentHTML('beforeend',
        `
      <div class="select-search-buttons level is-mobile">
        <button type="button" class="button level-item" data-action="${this.identifier}#close">Закрыть</button>
        <button type="button" class="button level-item has-text-danger" data-action="${this.identifier}#clear">Очистить</button>
      </div>
      `
      );
    }

  }

  addEvents() {
    let dropdown = this.dropdownTarget;
    this.intputSearchTarget.addEventListener('input', (e) => {
      this.filter(e.target.value);
    });
    this.intputResultsTarget.addEventListener('click', () => {
      dropdown.style.display = 'block';
    });
    document.addEventListener("click", (event) => {
      if (event.target.closest('.dropdown-item, .select-search-box')) return;
      dropdown.style.display = 'none';
    });
    window.onblur = () => {
      dropdown.style.display = 'none';
    };
  }

  filterEmpty() {
    this.intputSearchTarget.value = '';
    this.filter('');
  }

  filter(pattern) {
    pattern = pattern.replace(/(?=[() ])/g, '\\');
    this.query = new RegExp(`(${pattern})`, "ig");
    this.filteredOptions = this.options.filter((o) => {
      return o.name.match(this.query)
    });
    this.render();
  }

  select(event) {
    let id = event.target.dataset.branchId;
    this.optionsSelect(id)
    if (!this.multiple) this.dropdownTarget.style.display = 'none';
  }

  apply() {
    this.selectTarget.value = "";
    this.selections.forEach((selection) => {
      this.selectTarget.querySelector('[value="' + selection.id + '"]').selected = true;
    });
    this.selectTarget.dispatchEvent(new Event('change'));
  }

  highlight(text, id) {
    let result = text;
    if (this.query) {
      result = text.replace(this.query, "<span data-branch-id='" + id + "' class='select-search-highlight'>$1</span>");
    }
    return result;
  }

  optionsSelect(selectedId) {
    let uniq_selections = [];
    let ids = new Set(this.selections.map(element => element.id));
    if (ids.has(selectedId)) {
      ids.delete(selectedId);
    } else {
      ids.add(selectedId);
    };
    ids.forEach((id) => {
      let option = this.options.find(x => x.id === id)
      uniq_selections.push({ id: id, name: option.name, displayName: option.displayName });
    });
    if (!this.multiple) uniq_selections = uniq_selections.slice(-1);
    this.selections = uniq_selections;
    this.render();
  }

  clear() {
    this.intputSearchTarget.value = '';
    this.selections = [];
    this.filter('');
  }

  close() {
    this.dropdownTarget.style.display = 'none';
  }

  render() {
    this.listTarget.innerHTML = '';
    this.filteredOptions.forEach(o => {
      let selected = this.selections.map(element => element.id).includes(o.id) ? 'is-active' : '';
      this.listTarget.insertAdjacentHTML('beforeend', `<a class="dropdown-item ${selected}" data-branch-id="${o.id}"
                                                      data-action="${this.identifier}#select">${this.highlight(o.displayName, o.id)}</a>`)
    });
    if (this.filteredOptions.length == 0) {
      this.listTarget.insertAdjacentHTML('beforeend', `<a class="dropdown-item">Нет совпадений</a>`)
    };
    this.intputResultsTarget.value = this.selections.map(element => element.displayName).join(', ');
    this.apply();
  }
}
